const topics = [
	"truth",
	"dream",
	"invest",
	"exchange",
	"gaming",
	"btc",
	"motivation",
	"philosophy",
	"personal",
	"photography",
	"humanity",
	"bitcoin",
	"bitcoin Cash",
	"business",
	"society",
	"depression",
	"art",
	"food",
	"awareness",
	"healing",
	"wallet",
];
export default topics;
